import {ClickEvent} from "../../../infrastructure/models/analytics/click-event";
import {APP} from "../../../core/app/consts";

export class ShowAllClickEvent extends ClickEvent {
  source: APP.ANALYTICS.SOURCES;

  constructor(source: APP.ANALYTICS.SOURCES) {
    super('', 'click', 'show-all');

    this.source = source;
  }

  get properties() {
    const properties = super.properties;

    properties.source = this.source;

    return properties;
  }

}
